import api from '@/services/api'

const getFeedbacks = async (userId, type, page, filters, role) => {
    try {
        const resp = await api.post(`feedbacks/list/${userId}`, {
            type,
            with: 'valuer;evaluated;askings;answers;comments',
            filter:
                'id;valuer_id;evaluated_id;category;archived_at;updated_at;status;valuer.name;valuer.picture;evaluated.name;evaluated.picture;answers;comments;is_spontaneous',
            per_page: 10,
            page,
            ...filters,
            scope: role,
        })

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

const getCount = async (userId, filters, types, scope) => {
    try {
        const resp = await api.post(`feedbacks/list/${userId}/dashboard`, {
            ...filters,
            types,
            scope,
        })

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export { getFeedbacks, getCount }
